export const formatPrice = (price) => {
  const absolutePrice = Math.abs(price) / 100;
  return (price < 0 ? "-$" : "$") + absolutePrice;
};
